import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    year: Yup.string()
    .required()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(4, 'Please enter a valid year')
    .max(4, 'Please enter a valid year'),
    amount: Yup.number().nullable().required("Amount is required")
});